import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    delete: translate({ id: 'global.delete' }),
    deleteNormalDay: translate({ id: 'setup.vehicleAssignments.deleteNormalDay.tooltip' }),
    edit: translate({ id: 'global.edit' }),

    recurrenceDescription: (type: string) => {
      switch (type) {
        case 'DATE':
          return translate({ id: 'setup.vehicleAssignments.list.type.date' })

        case 'WEEKLY':
          return translate({ id: 'setup.vehicleAssignments.list.type.weekly' })

        case 'MONTHLY':
          return translate({ id: 'setup.vehicleAssignments.list.type.monthly' })

        case 'ANNUAL':
          return translate({ id: 'setup.vehicleAssignments.list.type.annual' })

        case 'any':
          return translate({ id: 'setup.vehicleAssignments.list.type.default' })

        default:
          return ''
      }
    },
  }))

  return api
}
